import React from 'react';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";
import styled from 'styled-components';
import { numberToCurrency } from 'vqp-common';

import { fetchDailyHistory } from '../../redux/actions/dashboard'
import { BarChart } from '.'
import moment from 'moment';
import useFetch from '../../utils/useFetch';

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;
`

const labelFormatter = (val, opts) => {
    if (opts.seriesIndex === 0) {
        return numberToCurrency(Number(val))
    }
    return val
}

const yFormatter = (val) => {
    return numberToCurrency(Number(val))
}


export const DailyChartPanel = ({filterDates}) => {

    const dailyHistory = useFetch(fetchDailyHistory, filterDates)

    const drawChart = () => {
        if (dailyHistory.loading) { 
            return (
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
            )
        } else if (dailyHistory.response) {
            return (
                <BarChart 
                    title="Pedidos e Faturamento diários" 
                    labels={dailyHistory.response.labels} 
                    datasets={dailyHistory.response.datasets} 
                    type="line"
                    yFormatters={[yFormatter, null]}
                    labelFormatter={labelFormatter}
                    xaxis={{
                        type: 'datetime',
                        min: moment(filterDates.initial).startOf('day').valueOf(),
                        max: moment(filterDates.final).endOf('day').valueOf(),
                    }}
                />
            )
        }
        return null
    }
    
    return (
        <Grid>
            {drawChart()}
        </Grid>
    )
}